(function () {
  'use strict';
  if (window.__PW_CART_FAST__) return;
  window.__PW_CART_FAST__ = true;

  function dispatchCartOpen(source) {
    var drawer = document.querySelector('header-drawer[open="cart:open"]');
    if (!drawer || drawer.classList.contains('is-active')) return;
    (source || drawer).dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
  }

  document.addEventListener('mc:cart:open', function (event) {
    dispatchCartOpen(event.target);
  });

  document.addEventListener('ajaxProduct:added', function (event) {
    window.setTimeout(function () {
      dispatchCartOpen(event.target);
    }, 40);
  });
})();
